import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { get_support_tickets_api } from "../../DAL/SupportTickets";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../Components/GeneralComponents/PageLoader";
import { useContent } from "../../hooks/useContent";
import CustomMUITable from "../../Components/GeneralComponents/CustomMUITable/CustomMUITable";
import moment from "moment/moment";
import { get_ticket_trash_api } from "../../DAL/SupportTickets";
import ConfirmationPopup from "../../Components/GeneralComponents/ConfirmationPopup";

const SupportTickets = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { setPageHeading } = useContent();
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("status");
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [updatedCases, setUpdatedCases] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedObject, setSelectedObject] = useState({});

  const loadCases = async (e) => {
    if (e) e.preventDefault();
    setIsLoadingPage(true);
    const result = await get_support_tickets_api({ search, sort });
    if (result.code === 200) {
      const tickets = result.tickets.map((ticket) => {
        const createdAt = moment(ticket.created_at).format(
          "DD-MM-YYYY HH:mm A"
        );
        return { ...ticket, createdAt };
      });
      setUpdatedCases(tickets);
    } else {
      enqueueSnackbar(`${result.message}`, { variant: "error" });
    }
    setIsLoadingPage(false);
  };

  useEffect(() => {
    setPageHeading("Support Tickets");
    loadCases();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- initial list load once on mount
  }, []);

  const handleChangeSearch = (e) => setSearch(e.target.value);
  const handleChangeSort = (e) => setSort(e.target.value);

  const handleBack = () => navigate("/home");
  const handleCreate = (e) => navigate("/support-tickets/create-ticket");

  if (isLoadingPage) return <PageLoader />;

  const TABLE_HEAD = [
    { id: "number", label: "#", type: "number" },
    { id: "ticket_id", label: "Ticket ID" },
    { id: "ticket_title", label: "Ticket Title" },
    { id: "priority", label: "Priority" },
    { id: "status", label: "Current Status" },
    { id: "createdAt", label: "Created At" },
    {
      id: "action",
      label: "Action",
      type: "action",
    },
  ];

  const handleEdit = (data) => {
    navigate(`/support-tickets/edit-ticket/${data.ticket_id}`);
  };

  const handleDetail = (data) => {
    navigate(`/support-tickets/detail/${data.ticket_id}`);
  };
  const handleTrashSupportTicket = async () => {
    setIsDeleting(true);
    try {
      const result = await get_ticket_trash_api(selectedObject.ticket_id);
      if (result.code === 200) {
        setUpdatedCases((old) =>
          old.filter((data) => data.ticket_id !== selectedObject.ticket_id)
        );
        enqueueSnackbar(`${result.message}`, { variant: "success" });
      } else {
        enqueueSnackbar(`Error moving support ticket to trash: ${result.message}`, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(`Error moving support ticket to trash: ${error.message || "An error occurred"}`, { variant: "error" });
    } finally {
      setIsDeleting(false);
      setOpenDelete(false);
      setSelectedObject(null);
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedObject(item);
    setOpenDelete(true);
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },
    {
      label: "Detail",
      icon: "gg:details-more",
      handleClick: handleDetail,
    },
    {
      label: "Move to Trash",
      icon: "ant-design:delete-twotone",
      handleClick: handleDeleteClick,
    },
  ];

  return (
    <div className="login-page container">
      <div className="d-flex justify-content-center">
        <div className="container mx-auto">
          <div className="form-wrapper">
            <form onSubmit={loadCases}>
              <div className="row mb-3">
                <div className="col">
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="cancel-button"
                      onClick={handleBack}
                    >
                      <Icon icon="mdi:arrow-left" /> Back
                    </button>
                    <button
                      type="button"
                      className="theme-button"
                      onClick={handleCreate}
                    >
                      <Icon icon="mdi:plus" /> Create New Ticket
                    </button>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <div className="search_sort_box d-flex gap-2 align-items-center">
                    <div className="form-group flex-1">
                      <label htmlFor="name">Search</label>
                      <div className="input-wrapper">
                        <Icon icon="mdi:magnify" className="input-icon" />
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Type a search string"
                          value={search}
                          onChange={handleChangeSearch}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Sort By</label>
                      <div className="input-wrapper">
                        <Icon
                          icon="mdi:filter-variant"
                          className="input-icon"
                        />
                        <select
                          value={sort}
                          onChange={handleChangeSort}
                          className="form-select"
                        >
                          <option value="status">Status</option>
                          <option value="priority">Priority</option>
                          <option value="created_at">
                            Creation Date
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group">
                      <label style={{ visibility: 'hidden' }}>Go</label>
                      <button
                        type="submit"
                        className="theme-button"
                        onClick={loadCases}
                        style={{ width: '100%' }}
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <CustomMUITable
                TABLE_HEAD={TABLE_HEAD}
                data={updatedCases}
                MENU_OPTIONS={MENU_OPTIONS}
                hide_search={true}
              />
              <ConfirmationPopup
                openDelete={openDelete}
                setOpenDelete={setOpenDelete}
                title={
                  "Are you sure you want to move this support ticket to trash?"
                }
                handleAgree={handleTrashSupportTicket}
                isLoading={isDeleting}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportTickets;
